import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { createArea } from 'api/areas';
import { useFeedback } from 'contexts/feedback';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function AreasCreate() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const cache = useQueryClient();
    const navigate = useNavigate();
    const { setSuccess } = useFeedback();

    const { mutate: create } = useMutation({
        mutationKey: ['createArea'],
        mutationFn: createArea,
        onSuccess: (data) => {
            cache.invalidateQueries(['areas']);
            setSuccess('Area creata con successo!');
            return navigate(`/areas/${data?._id}/edit`);
        },
        onError: (error) => {
            console.error("Error creating area:", error);
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        const formData = {
            name: e.target.name.value,
            description: e.target.description.value
        }

        create({data: formData});
    }


    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>Crea nuova area</p>
                    </div>

                    <div className=''>
                        <form onSubmit={onSubmitHandler} className='flex flex-col gap-6'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome"
                            />

                            <TextInput
                                label="Descrizione"
                                name="description"
                                placeholder="Descrizione"
                            />

                            <div className='flex justify-between pt-6'>
                                <Link to="/settings/areas" className='hover:bg-verylight text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Annulla</Link>
                                <Button submit>Salva e crea</Button>
                            </div>
                        </form>
                    </div>

                </Container>
            </div>
        </>
    )
}
